// Chakra imports
import {
  Avatar, Button,
  Flex, Link,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import React, {useState} from "react";
import {Element} from "react-scroll";
import {FaCrown, FaRegUser} from "react-icons/fa";

const Header = ({
                  firstName,
                  lastName,
                  email,
                  hasSubscribed,
                }) => {
  const textColor = useColorModeValue("gray.700", "white");
  const [startRedirectingToSubscription, setStartRedirectingToSubscription] = useState(false);


  return (
    <Card
      w={{sm: "100%", lg: "70%"}}
      alignSelf={{lg: "flex-end"}}
      justifySelf={{lg: "flex-end"}}
    >
      <Element id="profiel" name="profiel">
        <CardBody>
          <Flex
            direction={{sm: "column", md: "row"}}
            justify="space-between"
            align="center"
            w="100%"
          >
            <Flex align="center">
              <Avatar
                name={email}
                w="80px"
                h="80px"
                me="22px"
                borderRadius="15px"
              />
              <Flex direction="column">
                <Text color={textColor} fontWeight="bold" fontSize="lg">
                  {firstName === undefined && lastName === undefined ? email : `${firstName} ${lastName}`}
                </Text>
                <Text color="gray.400" fontWeight="normal" fontSize="sm">
                  {email}
                </Text>
              </Flex>
            </Flex>
            <Flex
              align="center"
              alignSelf={{sm: "flex-start", lg: null}}
              mt={{sm: "16px", lg: null}}
              ms={{sm: "6px", lg: null}}
            >
              {hasSubscribed ? (
                  <>
                    <FaCrown color="gold" style={{marginRight: "6px"}}/>
                    <Text
                      color={textColor}
                      fontWeight="bold"
                      me="14px"
                      fontSize="sm"
                    >
                      Premium account
                    </Text>
                  </>
                ) :
                <>
                  <FaRegUser color="gray" style={{marginRight: "6px"}}/>
                  <Text
                    color={textColor}
                    fontWeight="normal"
                    me="14px"
                    fontSize="sm"
                  >
                    Proefabbonement
                  </Text>
                  <Link href={"/admin/dashboard/subscription"}>
                    <Button
                      isLoading={startRedirectingToSubscription}
                      colorScheme="yellow"
                      size="sm"
                      borderRadius="md"
                      fontWeight="bold"
                      onClick={() => {
                        setStartRedirectingToSubscription(true);
                      }}
                    >
                      Upgrade
                    </Button>
                  </Link>
                </>}
            </Flex>
          </Flex>
        </CardBody>
      </Element>
    </Card>
  );
};

export default Header;
